export const EMAILS = ['info@ednist-construction.com.ua', 'kcanakli@ednist-construction.com.ua']
export const PHONE_NUMBERS = ['+380981044444']
export const FORMATTED_PHONE_NUMBERS = ['+380 98 104 4444']
export const ADDRESS = 'Україна, 01032, м.Київ, вул. Саксаганського, будинок 74Б,  oфic 1'
export const FADE_ANIMATION_DURATION = 0.7
export const LIST_FADE_ANIMATION_DURATION = 0.5